export default __webpack_public_path__ + "media/images/react_icons/bank-line-01f96ed14d1374e07b76c5a24c5c0e0e.svg";